// Function to apply typing specific for thunks compatible with connect, this may be replaced with a connect overload later
function dispatchProps<T extends Record<string, (...args: any[]) => any>>(
  t: T,
): MappedDispatchProps<T> {
  return t as any;
}

export default dispatchProps;
